import genderFemaleSVG from '~/assets/images/communication/gender-female.svg'
import genderMaleSVG from '~/assets/images/communication/gender-male.svg'

export { genderFemaleSVG, genderMaleSVG }

export const GENDER_QUESTION = 'Select your gender'

export const GENDER_OPTIONS = [
  { key: 'male', i18nKey: 'onboarding.quizSingleChoice.genderV2.options.male' },
  {
    key: 'female',
    i18nKey: 'onboarding.quizSingleChoice.genderV2.options.female',
  },
] as const
